define('helper-content-getEntity',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    var f = function f(ID, arr) {
        var res, entity;

        if (!ID || !Array.isArray(arr)) {
            return null;
        }

        arr = [].concat(arr);

        for (var i = 0; i < arr.length; i++) {
            entity = arr[i];

            if (entity.hasOwnProperty('contentEntityId') && entity.contentEntityId === ID) {
                return entity.hasOwnProperty('contentEntity') && entity.contentEntity && _typeof(entity.contentEntity) === 'object' && Object.keys(entity.contentEntity).length !== 0 ? entity : null;
            } else if (entity.hasOwnProperty('children') && Array.isArray(entity.children) && entity.children.length) {
                res = f(ID, entity.children);
                if (res) {
                    return res;
                }
            }
        }

        return null;
    };

    exports.default = function (ID, arr) {
        return f(ID, arr);
    };
});
